export default __webpack_public_path__ + "static/media/logo.5269d69a.png";